<div class="container col-xxl-8 px-4 py-5" style="scroll-margin-top: 96px;">
  <div class="mb-4">
    <button type="button" class="btn btn-outline-secondary" (click)="goBack()">← Back to Home</button>
  </div>

  <!-- Page Title on Top -->
  <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-4">Quick Start / User Guide</h1>

  <!-- 1st subsection -->
  <div id="intro-service" class="qs-subsection py-5">
    <h2 class="display-5 lh-1 mb-3">Introducing GeoAstra NTRIP Service</h2>
    <img src="assets/images/landing/GeoAstra_ntrip_caster_rtk-via-internet.png"
         class="qs-subsection-img"
         alt="RTK via Internet"
         loading="lazy"
         (click)="openLightbox('assets/images/landing/GeoAstra_ntrip_caster_rtk-via-internet.png','RTK via Internet')">
    <p>Is your current NTRIP service provider too expensive? Is their NTRIP mount point too far away from you? Do you find it difficult or inconvenient to connect your RTK rover to your own base? Owning an RTK base and connecting it with our GeoAstra NTRIP Caster is the solution to all these problems.</p>
    <p>GeoAstra NTRIP Caster functions as a NTRIP hub on the internet, connecting your RTK base(s) and rovers.</p>
    <p>When you connect your RTK base(s) to our GeoAstra NTRIP Caster, your RTK base transforms into an Internet Base NTRIP Service. This means your RTK rovers, including survey GNSSs, robots, drones, agricultural equipment, and GNSS receivers, can now receive RTK correction data effortlessly.</p>
    <p>GeoAstra NTRIP Caster is incredibly user-friendly. With just a few clicks, you can sign up and obtain your free NTRIP caster mount points, and start using them in under 20 seconds. Apply cm-level accuracy to your projects today! Experience the easy, convenient, and affordable internet-based RTK technology with GeoAstra.</p>
  </div>

  <!-- 2nd subsection -->
  <div id="signup-login" class="qs-subsection py-5">
    <h2 class="display-5 lh-1 mb-3">Sign-up / Login</h2>
    <img src="assets/images/landing/signin_screen_no_bg.png"
         class="qs-subsection-img"
         alt="Sign In Screen"
         loading="lazy"
         (click)="openLightbox('assets/images/landing/signin_screen_no_bg.png','Sign In Screen')">
    <p>The GeoAstra NTRIP Caster login screen allows you to sign-up / login using your existing Apple, Google, or Microsoft account. This means no need for a new account or entering personal information.</p>
    <p>Using social sign-in is convenient and safe. It offers quick access without filling out forms and reduces the number of passwords to remember. Additionally, your personal information remains with the social platform, ensuring your data stays secure.</p>
    <p>Alternatively, you can create a new user ID and password directly on our website. Just make sure to enter a valid email address; our system will email you a verification link, and your account will only be activated once your email address has been verified.</p>
    <p>Enjoy a seamless, secure, and efficient sign-up / login experience with GeoAstra NTRIP Caster by simply selecting your preferred sign-in option.</p>
  </div>

  <!-- 3rd subsection -->
  <div id="after-login" class="qs-subsection py-5">
    <h2 class="display-5 lh-1 mb-3">After You Login</h2>
    <img src="assets/images/landing/dashboard_screen.png"
         class="qs-subsection-img"
         alt="Dashboard Screen"
         loading="lazy"
         (click)="openLightbox('assets/images/landing/dashboard_screen.png','Dashboard Screen')">
    <p>Upon your first login, a fully functional NTRIP caster mount point is automatically created for you. Our system will generate the mount point name, along with the usernames and passwords for both your RTK base and rover. Each free user account includes 1 mount point, supporting 1 RTK base connection and up to 2 rover connections. If you need additional capacity, consider upgrading your subscription plan.</p>
    <p>The passwords here are displayed as plain text rather than being replaced by asterisks (*). This is intentional, as users need to see the actual password to enter it into their RTK device.</p>
    <p>For detailed descriptions of each page you'll see after logging in, please <a href="https://community.geoastra.com/docs/after-login/" target="_blank" rel="noopener">click here</a>.</p>
  </div>

  <!-- 4th subsection -->
  <div id="configure-rtk" class="qs-subsection py-5">
    <h2 class="display-5 lh-1 mb-3">Configure your RTK Bases and Rovers</h2>
    <img src="assets/images/landing/RTK_Base_and_Rover_Settings.png"
         class="qs-subsection-img"
         alt="RTK Base and Rover Settings"
         loading="lazy"
         (click)="openLightbox('assets/images/landing/RTK_Base_and_Rover_Settings.png','RTK Base and Rover Settings')">
    <p>All the settings required for connecting your RTK base and rover can be found on the Dashboard page mentioned above. Please note that the mount point, username, and password are case sensitive, so enter them carefully.</p>
    <p>Most RTK bases on the market use NTRIP V1 and do not require a username. However, if your RTK base uses NTRIP V2, a username is necessary.</p>
  </div>

  <!-- Lightbox overlay -->
  <div *ngIf="lightboxOpen" class="lightbox-backdrop" (click)="closeLightbox()">
    <div class="lightbox-content" (click)="$event.stopPropagation()">
      <button type="button" class="btn-close lightbox-close" aria-label="Close" (click)="closeLightbox()"></button>
      <img [src]="lightboxSrc" [alt]="lightboxAlt" class="img-fluid w-100" />
    </div>
  </div>
</div>
